import React from "react";
import { Scale, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0d1a2c] px-5 py-12 text-[#8a96a4] md:px-10">
      <div className="mx-auto max-w-[1180px]">
        <div className="flex flex-col items-start justify-between gap-6 border-b border-[#1a2a40] pb-8 md:flex-row md:items-center">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#0e1a2b] ring-1 ring-[#1a2a40]">
              <Scale className="h-5 w-5 text-[#b89c60]" strokeWidth={2.6} />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-serif-display text-[18px] text-[#ebe6d6]">
                Pires Advogados
              </span>
              <span className="text-[11px] font-semibold tracking-widest-custom uppercase text-[#6a7889]">
                Thiago Alves Pires · OAB/SP 406.256
              </span>
            </div>
          </div>

          <a
            href="https://wa.me/5514998040911"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[14px] text-[#b89c60] transition hover:text-[#cdb574]"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={2.4} />
            WhatsApp (14) 99804-0911
          </a>
        </div>

        <div className="mt-8 space-y-4 text-center">
          <p className="mx-auto max-w-3xl text-[12px] leading-relaxed text-[#6a7889]">
            Conteúdo informativo conforme Provimento 205/2021 OAB. As informações desta
            página não garantem resultado judicial; cada caso depende de análise documental
            e jurídica específica.
          </p>
          <p className="text-[12px] text-[#54657a]">
            © {new Date().getFullYear()} Pires Advogados · São Paulo/SP
          </p>
        </div>
      </div>
    </footer>
  );
}
